import React, { useState, useContext } from "react"

import { Grid } from "@material-ui/core"
import {
  InputOptionMaster,
  InputReactDatepicker,
  InputTextMaster,
  Loading,
} from "App/Component/ui"

import { PencilIcon, SearchIcon } from "App/Assets"
import { STYLE_PENJUALAN, urlGetKasBank, urlGetGudang, RmExternal } from "."
import { useSelectOption } from "App/hooks"
import {
  BILLING_INPUT_TAGIHAN,
  TYPE_INSTANCE3,
  TYPE_INSTANCE4,
  valueTipePembayaran,
} from "App/constants"
import { defaultToastError, isNull } from "App/utils/helpers"
import { FormContext } from "../context/FormContext"
import { ModalKunjunganBaru } from "App/Component/layout/Registrasi/KunjunganRawatJalan/ui"
import { messageError } from "utils/all"
import { useSelector } from "react-redux"
import { useDispatchWrapper } from "hooks"
import {
  changeActiveMenu,
  changeActiveTab,
  changePagePropsInputTagihan,
} from "App/Component/layout/Wrapper/context/actions"
import {
  getByFilterTagihan,
  getDataEditTagihan,
} from "App/Component/layout/Tagihan/DaftarTagihan/helpers"

export default function FormInputPenjualan() {
  const classes = STYLE_PENJUALAN()
  const [showModalKunjunganBaru, setShowModalKunjunganBaru] = useState(false)
  const { dispatch, handleClickMenu } = useDispatchWrapper()
  const { formData, setFormData } = useContext(FormContext)
  const [showRmExt, setShowRmExt] = useState(false)
  const master = useSelector(({ master }) => master)
  const asuransi = master.asuransi.list_select
  const dokter = master.dokter.list_select
  const kelas = master.kelas_kunjungan.list_select
  const jenisLayanan = master.all_jenis_layanan.list_select
  const [loading, setLoading] = useState(false)

  const kasBank = useSelectOption(
    true,
    urlGetKasBank,
    TYPE_INSTANCE3,
    "id",
    "nama",
  )

  const gudang = useSelectOption(
    true,
    urlGetGudang,
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "data",
  )

  const handleChange = (text) => (e) => {
    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        [text]: e.target.value,
      }
    })
  }

  const changeSelectWithLocalStorage = (e, name_id, name_label) => {
    if (isNull(e)) {
      setFormData({
        ...formData,
        [name_id]: null,
        [name_label]: "Pilih",
      })
    } else {
      setFormData({
        ...formData,
        [name_id]: e?.value,
        [name_label]: e?.label,
      })
    }
  }

  const handleClickSelect = (row) => {
    setFormData({
      ...formData,
      nama: row.fullname,
      rm_id: row.id,
      is_external: 1,
      intext: row.is_external,

      asuransi_id: row.insurance_id,
      asuransi: row.insurance_name,
      noasuransi: row.insurance_number,
    })
    setShowModalKunjunganBaru(false)
  }

  const handleClickTagihan = async (tagihanID) => {
    setLoading(true)
    const tagihanDetail = await getByFilterTagihan(
      {
        kategori_pencarian: 1,
        kata_kunci: tagihanID,

        nama: "",
        rm_id: "",
        eklaim_status: "",

        asuransi_id: null,
        asuransi_name: "Pilih Asuransi",

        jenis_layanan_id: null,
        jenis_layanan_name: "Pilih Jenis Layanan",

        tanggal_awal: "",
        tanggal_akhir: "",
      },
      1,
      1,
    )

    if (tagihanDetail.state && tagihanDetail.data.length > 0) {
      Promise.resolve()
        .then(() => {
          dispatch(changeActiveMenu(BILLING_INPUT_TAGIHAN))
        })
        .then(async () => {
          const propsPageInputTagihan = await getDataEditTagihan(
            tagihanDetail.data[0],
          )
          if (propsPageInputTagihan.state) {
            dispatch(changePagePropsInputTagihan(propsPageInputTagihan.data))
            dispatch(changeActiveTab(BILLING_INPUT_TAGIHAN))

            handleClickMenu({
              code: BILLING_INPUT_TAGIHAN,
              name: "Input Tagihan",
            })
            setLoading(false)
          } else {
            defaultToastError(propsPageInputTagihan.message)
            setLoading(false)
          }
        })
    } else {
      defaultToastError("Data tidak ditemukan")
      setLoading(false)
    }
  }

  return (
    <>
      {showModalKunjunganBaru && (
        <ModalKunjunganBaru
          formData={formData}
          setFormData={setFormData}
          handleClickSelect={handleClickSelect}
          setShowModal={() => setShowModalKunjunganBaru(false)}
        />
      )}

      <Loading show={loading} />

      {showRmExt && <RmExternal setShowModal={() => setShowRmExt(false)} />}
      <form action="">
        <Grid container>
          <Grid item sm={6}>
            <Grid container>
              <Grid item sm={6}>
                <p
                  style={{
                    fontSize: "14px",
                  }}
                >
                  ID Penjualan
                </p>
                <div
                  className={classes.id}
                  style={{
                    fontSize: "21px",
                  }}
                >
                  {isNull(formData.penjualan_id) ? "-" : formData.penjualan_id}
                </div>
              </Grid>

              <Grid item sm={6}>
                <p
                  style={{
                    fontSize: "14px",
                  }}
                >
                  ID Tagihan/Kunjungan
                </p>
                <div
                  className={classes.id}
                  style={{
                    fontSize: "21px",
                  }}
                >
                  {isNull(formData.tagihan_id) ? (
                    "-"
                  ) : (
                    <>
                      <div
                        onClick={() => handleClickTagihan(formData.tagihan_id)}
                        style={{
                          color: "#0FB054",
                          cursor: "pointer",
                        }}
                      >
                        {formData.tagihan_id}
                      </div>
                    </>
                  )}{" "}
                  /{" "}
                  {isNull(formData.kunjungan_id) ? "-" : formData.kunjungan_id}
                </div>
              </Grid>
            </Grid>
          </Grid>

          <Grid item sm={6}>
            <Grid container justifyContent="flex-end" spacing={1}>
              <Grid item sm={6}>
                <InputOptionMaster
                  name="kelas_id"
                  label="KELAS"
                  id="kelas_id"
                  withSearch={true}
                  data={kelas}
                  value={formData.kelas_id}
                  labelValue={formData.kelas_name}
                  disabled={isNull(formData.penjualan_id) ? false : true}
                  readOnly={isNull(formData.penjualan_id) ? false : true}
                  error={true}
                  message={messageError.required}
                  onChange={(e) =>
                    changeSelectWithLocalStorage(e, "kelas_id", "kelas_name")
                  }
                />
              </Grid>
              <Grid item sm={6}>
                <InputReactDatepicker
                  selected={formData.date}
                  label="TANGGAL"
                  dateFormat="dd/MM/yyyy HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  timeIntervals={5}
                  // withToday={isNull(formData.penjualan_id) ? true : false}
                  disabled={isNull(formData.penjualan_id) ? false : true}
                  readOnly={isNull(formData.penjualan_id) ? false : true}
                  isClearable={false}
                  handleChangeToday={(e) => {
                    if (isNull(formData.penjualan_id)) {
                      setFormData({
                        ...formData,
                        date: e,
                      })
                    } else {
                      return
                    }
                  }}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      date: e,
                    })
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <div className="mt-1">
          <Grid container>
            <Grid item sm={3}>
              <div>
                <p className={classes.formControlLabel}>ID RM</p>
                <div className={classes.parentId}>
                  {isNull(formData.kunjungan_id) ||
                  isNull(formData?.penjualan_id) ? (
                    <>
                      <div
                        onClick={() =>
                          setShowModalKunjunganBaru(!showModalKunjunganBaru)
                        }
                      >
                        <button type={"button"} className={classes.inputButton}>
                          <SearchIcon
                            width={"16"}
                            height={"16"}
                            fill={"#333"}
                          />
                        </button>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  <div
                    style={{
                      marginLeft: `${
                        isNull(formData.kunjungan_id) ||
                        isNull(formData?.penjualan_id)
                          ? "1rem"
                          : ""
                      }`,
                      fontWeight: "600",
                    }}
                  >
                    {formData.rm_id}
                  </div>
                </div>
                <p className={classes.error}>UNTUK PENJUALAN EXTERNAL </p>
              </div>

              <div className="mt-2">
                <p className={classes.formControlLabel}>Nama RM</p>
                <div className={classes.parentId}>
                  <div>
                    <button
                      type={"button"}
                      className={classes.inputButton}
                      onClick={() => setShowRmExt(!showRmExt)}
                    >
                      <PencilIcon width={"14"} height={"14"} fill={"#333"} />
                    </button>
                  </div>
                  <div
                    style={{
                      marginLeft: "1rem",
                      fontWeight: "600",
                    }}
                  >
                    {formData.nama === "" ? "-" : formData.nama}
                  </div>
                </div>
                <p className={classes.error}>UNTUK PENJUALAN EXTERNAL </p>
              </div>
            </Grid>

            <Grid item sm={9}>
              <Grid container spacing={1}>
                <Grid item sm={4}>
                  <InputOptionMaster
                    name="jenis_layanan_id"
                    label="JENIS LAYANAN"
                    id="jenis_layanan_id"
                    withSearch={true}
                    data={jenisLayanan}
                    value={formData.jenis_layanan_id}
                    labelValue={formData.jenis_layanan_name}
                    error={true}
                    message={messageError.required}
                    onChange={(e) =>
                      changeSelectWithLocalStorage(
                        e,
                        "jenis_layanan_id",
                        "jenis_layanan_name",
                      )
                    }
                  />
                </Grid>
                <Grid item sm={4}>
                  <InputOptionMaster
                    name="tipe_pembayaran_id"
                    label="TIPE PEMBAYARAN"
                    id="tipe_pembayaran_id"
                    withSearch={false}
                    data={valueTipePembayaran}
                    value={formData.tipe_pembayaran_id}
                    onChange={handleChange("tipe_pembayaran_id")}
                  />
                </Grid>
                <Grid item sm={4}>
                  <InputOptionMaster
                    name="gudang_id"
                    label="GUDANG"
                    id="gudang_id"
                    withSearch={true}
                    disabled={isNull(formData.penjualan_id) ? false : true}
                    readOnly={isNull(formData.penjualan_id) ? false : true}
                    data={gudang}
                    value={formData.gudang_id}
                    labelValue={formData.gudang_name}
                    error={true}
                    message={messageError.required}
                    onChange={(e) =>
                      changeSelectWithLocalStorage(
                        e,
                        "gudang_id",
                        "gudang_name",
                      )
                    }
                  />
                </Grid>
              </Grid>

              <div className="mt-2">
                <hr />
              </div>
            </Grid>
          </Grid>
        </div>

        <div className="mt-1">
          <Grid container spacing={1}>
            <Grid item sm={3}>
              <InputTextMaster
                name="petugas"
                label="PETUGAS"
                id="petugas"
                value={formData.petugas}
                onChange={handleChange("petugas")}
                error={true}
                message={messageError.required}
                placeholder="Petugas"
              />
            </Grid>

            <Grid item sm={9}>
              <Grid container spacing={1}>
                <Grid item sm={3}>
                  <InputOptionMaster
                    name="dokter_id"
                    label="DPJP"
                    id="dokter_id"
                    withSearch={true}
                    data={dokter}
                    labelValue={formData.dokter_name}
                    value={formData.dokter_id}
                    error={true}
                    message={"Selain external, wajib diisi"}
                    onChange={(e) =>
                      changeSelectWithLocalStorage(
                        e,
                        "dokter_id",
                        "dokter_name",
                      )
                    }
                  />
                </Grid>
                <Grid item sm={3}>
                  <InputOptionMaster
                    name="kas_bank_id"
                    label="KAS BANK"
                    id="kas_bank_id"
                    withSearch={true}
                    data={kasBank}
                    value={formData.kas_bank_id}
                    labelValue={formData.kas_bank_name}
                    error={true}
                    message={messageError.required}
                    onChange={(e) =>
                      changeSelectWithLocalStorage(
                        e,
                        "kas_bank_id",
                        "kas_bank_name",
                      )
                    }
                  />
                </Grid>
                <Grid item sm={3}>
                  <InputOptionMaster
                    name="asuransi_id"
                    label="ASURANSI"
                    id="asuransi_id"
                    withSearch={true}
                    data={asuransi}
                    disabled={isNull(formData.penjualan_id) ? false : true}
                    readOnly={isNull(formData.penjualan_id) ? false : true}
                    value={formData.asuransi_id}
                    labelValue={formData.asuransi}
                    onChange={(e) =>
                      changeSelectWithLocalStorage(e, "asuransi_id", "asuransi")
                    }
                  />
                </Grid>

                <Grid item sm={3}>
                  <InputTextMaster
                    name="noasuransi"
                    label="NO ASURANSI"
                    id="noasuransi"
                    placeholder="No Asuransi"
                    value={formData.noasuransi}
                    onChange={handleChange("noasuransi")}
                    error={true}
                    message={"Selain umum, wajib diisi"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </form>
    </>
  )
}
